module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Name","prompt":"Prompt","keyPoints":"Key points","keyFactsLabels":"Key facts labels","questionsInitial":"Seed questions"}}')
  delete Component.options._Ctor
}
